export default "__VITE_ASSET__nteZYFyW__"